(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initAdvancedHome = (root) => {
    if (!root || root.dataset.effectsInitialized === 'true') return;
    root.dataset.effectsInitialized = 'true';

    const revealGroups = [
      ['.kg-home__trust-item', 90],
      ['.kg-home__product', 90],
      ['.kg-home__heading-row', 0],
      ['.kg-home__range', 120],
      ['.kg-home__offer > *', 120],
      ['.kg-home__why, .kg-home__process', 140],
      ['.kg-home__process-grid article', 90],
      ['.kg-home__review-grid > *', 120],
      ['.kg-home__reassurance .kg-home__shell > div', 80],
    ];

    const revealElements = [];
    revealGroups.forEach(([selector, delayStep]) => {
      root.querySelectorAll(selector).forEach((element, index) => {
        element.classList.add('kg-reveal');
        element.style.setProperty('--kg-delay', `${Math.min(index * delayStep, 420)}ms`);
        revealElements.push(element);
      });
    });

    const showEverything = () => {
      revealElements.forEach((element) => element.classList.add('is-visible'));
      root.classList.add('is-effects-ready');
    };

    const initMobileRail = (rail) => {
      const wrapper = rail.closest('.kg-home__shell');
      if (!wrapper || rail.dataset.mobileRailInitialized === 'true') return;
      rail.dataset.mobileRailInitialized = 'true';
      wrapper.classList.add('kg-home__rail-shell');

      const previousButton = document.createElement('button');
      const nextButton = document.createElement('button');
      previousButton.type = 'button';
      nextButton.type = 'button';
      previousButton.className = 'kg-home__rail-button kg-home__rail-button--prev';
      nextButton.className = 'kg-home__rail-button kg-home__rail-button--next';
      previousButton.setAttribute('aria-label', 'Previous cards');
      nextButton.setAttribute('aria-label', 'Next cards');
      previousButton.innerHTML = '<span aria-hidden="true"></span>';
      nextButton.innerHTML = '<span aria-hidden="true"></span>';
      wrapper.append(previousButton, nextButton);

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
      const updateButtons = () => {
        const canScroll = isMobile() && rail.scrollWidth > rail.clientWidth + 2;
        const atStart = rail.scrollLeft <= 2;
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        previousButton.hidden = !canScroll || atStart;
        nextButton.hidden = !canScroll || atEnd;
      };
      const move = (direction) => {
        rail.scrollBy({
          left: direction * Math.max(rail.clientWidth * 0.85, 220),
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      };

      previousButton.addEventListener('click', () => move(-1));
      nextButton.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
      requestAnimationFrame(updateButtons);
    };

    root.querySelectorAll('.kg-home__ranges-grid').forEach(initMobileRail);

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      showEverything();
      return;
    }

    root.classList.add('is-effects-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );

    revealElements.forEach((element) => observer.observe(element));

    const heroElements = root.querySelectorAll(
      '.kg-home__hero .kg-home__eyebrow, .kg-home__hero .kg-home__title, .kg-home__hero .kg-home__lead, .kg-home__hero-actions, .kg-home__hero-note'
    );
    heroElements.forEach((element, index) => {
      element.classList.add('kg-hero-enter');
      element.style.setProperty('--kg-hero-delay', `${120 + index * 110}ms`);
    });
    requestAnimationFrame(() => root.classList.add('is-hero-ready'));

    const progressBar = root.querySelector('.kg-home__scroll-progress span');
    const heroMedia = root.querySelector('.kg-home__hero-media img');
    let scrollFrame = 0;

    const updateScrollEffects = () => {
      scrollFrame = 0;
      const rootRect = root.getBoundingClientRect();
      const travel = Math.max(root.offsetHeight - window.innerHeight, 1);
      const progress = Math.min(Math.max(-rootRect.top / travel, 0), 1);
      if (progressBar) progressBar.style.transform = `scaleX(${progress})`;

      if (heroMedia && rootRect.top > -window.innerHeight) {
        const heroOffset = Math.min(Math.max(window.scrollY * 0.1, 0), 80);
        heroMedia.style.setProperty('--kg-parallax', `${heroOffset}px`);
      }
    };

    const requestScrollUpdate = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(updateScrollEffects);
    };

    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    updateScrollEffects();

  };

  const initAll = (scope = document) => {
    if (scope.matches?.('.kg-home')) initAdvancedHome(scope);
    scope.querySelectorAll('.kg-home').forEach(initAdvancedHome);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
